import { render, staticRenderFns } from "./s-page.vue?vue&type=template&id=9e02520e"
import script from "./s-page.vue?vue&type=script&lang=js"
export * from "./s-page.vue?vue&type=script&lang=js"
import style0 from "./s-page.vue?vue&type=style&index=0&id=9e02520e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports